import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  FLAG_GETTING_PARCELS,
  GET_PARCELS,
  CLEAR_PARCEL,
  FLAG_PARCEL_ACTIVITY,
  GET_PARCEL,
  POST_CARGO_PRICE,
  CLEAR_CARGO_PRICE,
  CLEAR_CARGO_PRICES,
  CLEAR_PARCELS,
  PRINT_CARGO_VOUCHER_ON_MOUNT,
  FLAG_GETTING_INCOMES_PARCELS,
  GET_INCOMES_PARCELS,
  CLEAR_INCOMES_PARCELS,
  FLAG_GETTING_OTHER_INCOMES_PARCELS,
  GET_OTHER_INCOMES_PARCELS,
  CLEAR_OTHER_INCOMES_PARCELS,
  POST_CARGO_PRICE_BAGGAGE,
  CLEAR_CARGO_PRICE_BAGGAGE,
  FLAG_CARGO_PRICE_BAGGAGE_ACTIVITY,
  PRINT_CARGO_VOUCHER_STICKER
} from '../../../actions/types/cargo';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  salesSession: Immutable.Map({
    incomes: Immutable.Map(COLLECTION_SHAPE),
    loadingIncomes: false,
    otherIncomes: Immutable.List(),
    loadingOtherIncomes: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
    price: Immutable.Map(),
    printOnMount: false,
    print: false
  }),
  baggagePrice: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_PARCELS:
      return state.setIn(['all', 'loading'], payload);
    case GET_PARCELS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_PARCELS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_PARCEL_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_PARCEL:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_PARCEL:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case POST_CARGO_PRICE:
      return state.setIn(['current', 'price'], Immutable.Map(payload));
    case CLEAR_CARGO_PRICE:
      if (
        state
          .getIn(['current', 'price'])
          .findKey((price) => price.index === payload) !== undefined
      ) {
        const updatedPrices = state
          .getIn(['current', 'price'])
          .filter((price) => price.index !== payload)
          .map((price) => {
            if (price.index > payload) {
              return { ...price, index: price.index - 1 };
            }
            return price;
          });

        return state.setIn(['current', 'price'], updatedPrices);
      }

      return state;
    case CLEAR_CARGO_PRICES:
      return state.setIn(
        ['current', 'price'],
        INITIAL_STATE.getIn(['current', 'price']),
      );
    case PRINT_CARGO_VOUCHER_ON_MOUNT:
      return state.setIn(['current', 'printOnMount'], payload);
    case PRINT_CARGO_VOUCHER_STICKER:
      return state.setIn(['current', 'print'], payload);
    case FLAG_GETTING_INCOMES_PARCELS:
      return state.setIn(['salesSession', 'loadingIncomes'], payload);
    case GET_INCOMES_PARCELS:
      return state.setIn(['salesSession', 'incomes'], Immutable.Map(payload));
    case CLEAR_INCOMES_PARCELS:
      return state.setIn(
        ['salesSession', 'incomes'],
        INITIAL_STATE.getIn(['salesSession', 'incomes']),
      );
    case FLAG_GETTING_OTHER_INCOMES_PARCELS:
      return state.setIn(['salesSession', 'loadingOtherIncomes'], payload);
    case GET_OTHER_INCOMES_PARCELS:
      return state.setIn(
        ['salesSession', 'otherIncomes'],
        Immutable.List(payload),
      );
    case CLEAR_OTHER_INCOMES_PARCELS:
      return state.setIn(
        ['salesSession', 'otherIncomes'],
        INITIAL_STATE.getIn(['salesSession', 'otherIncomes']),
      );
    case POST_CARGO_PRICE_BAGGAGE:
      return state.setIn(['baggagePrice', 'content'], Immutable.Map(payload));
    case CLEAR_CARGO_PRICE_BAGGAGE:
      return state.setIn(
        ['baggagePrice', 'content'],
        INITIAL_STATE.getIn(['baggagePrice', 'content']),
      );
    case FLAG_CARGO_PRICE_BAGGAGE_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['baggagePrice', 'activity'],
          state.getIn(['baggagePrice', 'activity']).push(payload),
        );
      }
      return state.setIn(
        ['baggagePrice', 'activity'],
        state.getIn(['baggagePrice', 'activity']).pop(),
      );
    default:
      return state;
  }
};
